"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieDomain = exports.userOptedOutOfEssentialCookies = exports.getUpdatedWebClientIdSetCookieString = exports.getNewEssentialSessionCookieString = exports.getNewEssentialSessionCookie = exports.getUpdatedWebClientIdCookie = exports.getBlizzardClientId = exports.tryGetWebClientId = exports.getWebClientId = exports.hasOptedOutFromEssentialSession = exports.getScopedCookieDomain = exports.tryGetCookie = exports.hasNonceCookieSet = exports.hasAcceptedPerformanceCookies = exports.hasAcceptedSCCookies = exports.SC_BLIZZARD_CLIENT_ID_NAME = exports.SC_WEB_CLIENT_ID_NAME = exports.ESSENTIAL_SESSION_COOKIE_NAME = void 0;
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const cookie_1 = require("cookie");
const js_cookie_1 = __importDefault(require("js-cookie"));
const uuid_1 = require("uuid");
const web_env_1 = require("@snapchat/web-env");
const SC_ALLOWED_DOMAINS = new Set([".snapchat.com", ".snap-dev.net", "localhost"]);
const SC_ACCEPTED_COOKIES_NAME = "sc-cookies-accepted";
const PERFORMANCE_COOKIE_NAME = "Performance";
const SC_A_NONCE_COOKIE_NAME = "sc-a-nonce";
exports.ESSENTIAL_SESSION_COOKIE_NAME = "EssentialSession";
exports.SC_WEB_CLIENT_ID_NAME = "sc-wcid";
exports.SC_BLIZZARD_CLIENT_ID_NAME = "blizzard_client_id";
/* istanbul ignore next : Don't test library getter */
/**
 * WARNING: you need to first accept the cookie notice on prod, otherwise this will always return false. This is because we don't render Cookie Popup Banner on dev.
 */
const hasAcceptedSCCookies = () => js_cookie_1.default.get(SC_ACCEPTED_COOKIES_NAME) === "true";
exports.hasAcceptedSCCookies = hasAcceptedSCCookies;
/* istanbul ignore next : Don't test library getter */
const hasAcceptedPerformanceCookies = () => js_cookie_1.default.get(PERFORMANCE_COOKIE_NAME) === "true";
exports.hasAcceptedPerformanceCookies = hasAcceptedPerformanceCookies;
const hasNonceCookieSet = () => js_cookie_1.default.get(SC_A_NONCE_COOKIE_NAME) !== undefined;
exports.hasNonceCookieSet = hasNonceCookieSet;
function tryGetCookie(cookies, cookieName) {
    if (!cookies || typeof cookies !== "string") {
        return undefined;
    }
    const parsed = (0, cookie_1.parse)(cookies);
    return parsed[cookieName];
}
exports.tryGetCookie = tryGetCookie;
function getScopedCookieDomain(domain) {
    const subDomain = domain.substring(domain.indexOf("."));
    return subDomain.substring(0, subDomain.includes(":") ? subDomain.indexOf(":") : subDomain.length);
}
exports.getScopedCookieDomain = getScopedCookieDomain;
const hasOptedOutFromEssentialSession = (cookies) => tryGetCookie(cookies, exports.ESSENTIAL_SESSION_COOKIE_NAME) === "false"; // Learn about EssentialSession Cookies here - https://docs.google.com/document/d/1EjCg_7-uaVstzxDX54YhWs3WVdWsxtGow6zSnXXdGY4/edit and https://snapchat.quip.com/Lv7cAd7q5kLF
exports.hasOptedOutFromEssentialSession = hasOptedOutFromEssentialSession;
function getCookieOptions(hostHeader, expiryDate, path) {
    const baseOptions = {
        expires: new Date(expiryDate),
        path: path,
        secure: true,
        httpOnly: false,
        credentials: "same-origin",
    };
    if (hostHeader && typeof hostHeader === "string") {
        const cookieDomain = getScopedCookieDomain(hostHeader);
        if (SC_ALLOWED_DOMAINS.has(cookieDomain)) {
            return {
                ...baseOptions,
                domain: cookieDomain,
            };
        }
    }
    return baseOptions;
}
function getWebClientIdCookieOptions(hostHeader, isGdpr) {
    let expires;
    if (isGdpr) {
        // For GDPR countries, the expiry of the web_client_id should be set to 24 hours
        expires = new Date();
        expires.setDate(expires.getDate() + 1);
    }
    else {
        expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
    }
    return getCookieOptions(hostHeader, expires, "/");
}
const getWebClientId = (cookies) => {
    if ((0, exports.hasOptedOutFromEssentialSession)(cookies)) {
        js_cookie_1.default.remove(exports.SC_WEB_CLIENT_ID_NAME);
        return undefined;
    }
    return tryGetCookie(cookies, exports.SC_WEB_CLIENT_ID_NAME);
};
exports.getWebClientId = getWebClientId;
/**
 * Returns a Promise of the web client ID cookie, provided the user has opted into essential cookies.
 * @param cookies document.cookies
 */
const tryGetWebClientId = async (cookies) => {
    if ((0, exports.hasOptedOutFromEssentialSession)(cookies)) {
        js_cookie_1.default.remove(exports.SC_WEB_CLIENT_ID_NAME);
        return Promise.resolve(undefined);
    }
    return Promise.resolve(tryGetCookie(cookies, exports.SC_WEB_CLIENT_ID_NAME));
};
exports.tryGetWebClientId = tryGetWebClientId;
/**
 * blizzard_client_id cookie value is in the format "client_id:timestamp"
 * @param cookies document.cookies
 * @returns client_id extracted from the blizzard_client_id cookie
 */
const getBlizzardClientId = (cookies) => {
    const cookieValue = tryGetCookie(cookies, exports.SC_BLIZZARD_CLIENT_ID_NAME);
    return cookieValue?.split(":")[0];
};
exports.getBlizzardClientId = getBlizzardClientId;
const getUpdatedWebClientIdCookie = (cookies, host, isGdpr = true) => {
    if ((0, exports.hasOptedOutFromEssentialSession)(cookies)) {
        js_cookie_1.default.remove(exports.SC_WEB_CLIENT_ID_NAME);
        return undefined;
    }
    const currentWebClientId = tryGetCookie(cookies, exports.SC_WEB_CLIENT_ID_NAME);
    const webClientId = currentWebClientId ? currentWebClientId : (0, uuid_1.v4)();
    const webClientIdOptions = getWebClientIdCookieOptions(host, isGdpr);
    return {
        key: exports.SC_WEB_CLIENT_ID_NAME,
        value: webClientId,
        options: webClientIdOptions,
    };
};
exports.getUpdatedWebClientIdCookie = getUpdatedWebClientIdCookie;
function getNewEssentialSessionCookie(cookies, host) {
    if ((0, exports.hasOptedOutFromEssentialSession)(cookies)) {
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({ metricsName: "Cookies.EssentialSession.OptOut", value: 1 });
        }
        return;
    }
    const existingCookie = tryGetCookie(cookies, exports.ESSENTIAL_SESSION_COOKIE_NAME);
    if (!existingCookie) {
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        return {
            key: exports.ESSENTIAL_SESSION_COOKIE_NAME,
            value: "true",
            options: getCookieOptions(host, expires, "/"),
        };
    }
    // If Essential Cookie is already set, no new cookie needs to be set
    return undefined;
}
exports.getNewEssentialSessionCookie = getNewEssentialSessionCookie;
function getNewEssentialSessionCookieString(cookies, host) {
    const cookie = getNewEssentialSessionCookie(cookies, host);
    if (cookie) {
        const { key, value, options } = cookie;
        return (0, cookie_1.serialize)(key, value, options);
    }
}
exports.getNewEssentialSessionCookieString = getNewEssentialSessionCookieString;
function getUpdatedWebClientIdSetCookieString(cookies, host) {
    const cookie = (0, exports.getUpdatedWebClientIdCookie)(cookies, host);
    if (!cookie) {
        return undefined;
    }
    const { key, value, options } = cookie;
    return (0, cookie_1.serialize)(key, value, options);
}
exports.getUpdatedWebClientIdSetCookieString = getUpdatedWebClientIdSetCookieString;
/**
 * check if we can set wcid cookie for a browser.
 * note: client-side only, uses "document"
 */
const userOptedOutOfEssentialCookies = () => {
    if (typeof (0, web_env_1.getDocument)() === "undefined") {
        return undefined;
    }
    const cookies = (0, web_env_1.getDocument)()?.cookie;
    return (0, exports.hasOptedOutFromEssentialSession)(cookies);
};
exports.userOptedOutOfEssentialCookies = userOptedOutOfEssentialCookies;
/**
 * Returns the cookie domain.
 */
const getCookieDomain = (cookieDomain) => {
    // Use input value if specified
    if (cookieDomain)
        return cookieDomain;
    const window = (0, web_env_1.getWindow)();
    if (!window) {
        // This shouldn't happen, but let's make TS happy
        return "";
    }
    // window is available, we can reliably return the domain + TLD:
    const hostname = window.location.hostname.toLowerCase();
    const parts = hostname.split(".");
    if (parts.length < 2) {
        return hostname;
    }
    return parts[parts.length - 2] + "." + parts[parts.length - 1];
};
exports.getCookieDomain = getCookieDomain;
//# sourceMappingURL=sc-cookies.js.map